import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import './App.css';

import NavBar from './components/navbar/NavBar';
import ScrollToTop from './components/ScrollToTop';
import { SideMenu } from './components/sidemenu/SideMenu';
import { Footer } from './components/styled/Footer';
import { StyledMain, Wrapper } from './components/styled/Main';
import { storeActions } from './context/actions';
import { useStoreContext } from './context/initial';
import AsyncValdiationsPage from './pages/AsyncValidationsPage';
import GForm from './pages/components/GForm';
import GInput from './pages/components/GInput';
import ConstraintValidation from './pages/ConstraintValdiation';
import CustomChanges from './pages/CustomChanges';
import CustomValidations from './pages/CustomValidations';
import Misc from './pages/examples/Misc';
import SignInForm from './pages/examples/SignInForm';
import SignUpForm from './pages/examples/SignUpForm';
import FetchingData from './pages/FetchingData';
import HomePage from './pages/Home';
import Installation from './pages/Installation';
import Quickstart from './pages/Quickstart';
import UnderConstruction from './pages/UnderConstruction';
import GValidator from './pages/validators/GValidator';
import { defaultTheme } from './theme';


function App() {
    const { state, dispatch } = useStoreContext();

    useEffect(() => {
        const onResize = () => dispatch(storeActions.setMobile(window.innerWidth < 750));

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
        <ThemeProvider theme={{ ...defaultTheme, mode: state.mode }}>
            <Wrapper>
                <StyledMain>
                    <UnderConstruction />
                    {/*<BrowserRouter>*/}
                    {/*    <ScrollToTop />*/}
                    {/*    */}
                    {/*    <NavBar />*/}
                    {/*    <SideMenu />*/}
                    {/*    <div className='main'>*/}
                    {/*        <Routes>*/}
                    {/*            <Route path="/" element={<HomePage />} />*/}
                    {/*            <Route path="/installation" element={<Installation />} />*/}
                    {/*            <Route path="/quickstart" element={<Quickstart />} />*/}
                    {/*            <Route path="/constraint-validation" element={<ConstraintValidation />} />*/}
                    {/*            <Route path="/custom-validations" element={<CustomValidations />} />*/}
                    {/*            <Route path="/async-validations" element={<AsyncValdiationsPage />} />*/}
                    {/*            <Route path="/fetching-data" element={<FetchingData />} />*/}
                    {/*            <Route path="/custom-changes" element={<CustomChanges />} />*/}
                    {/*            <Route path="/components/gform" element={<GForm />} />*/}
                    {/*            <Route path="/components/ginput" element={<GInput />} />*/}
                    {/*            <Route path="/validators/gvalidator" element={<GValidator />} />*/}
                    {/*            <Route path="/examples/signinform" element={<SignInForm />} />*/}
                    {/*            <Route path="/examples/signupform" element={<SignUpForm />} />*/}
                    {/*            <Route path="/examples/misc" element={<Misc />} />*/}
                    {/*            <Route path="/under-construction" element={<UnderConstruction />} />*/}
                    {/*        </Routes>*/}
                    {/*    </div>*/}
                    {/*    <Footer>*/}
                    {/*        <span>*/}
                    {/*            © 2023 Copyright Tal Maman. All rights reserved.*/}
                    {/*        </span>*/}
                    {/*    </Footer>*/}
                    {/*</BrowserRouter>*/}
                </StyledMain>
            </Wrapper>
        </ThemeProvider>
    );
}

export default App;
